function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M25.687 24.587c.406.406 1.072.389 1.422-.067a13.999 13.999 0 002.638-11.17c-.104-.541-.656-.858-1.19-.715l-7.083 1.898c-.533.143-.838.693-.812 1.244a4.65 4.65 0 01-.432 2.197c-.207.443-.173.983.172 1.328l5.285 5.285z",
  fill: "url(#selection_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 3c0-.552-.448-1.004-1-.964a14 14 0 109.52 25.073c.456-.35.473-1.016.067-1.422l-5.285-5.285c-.345-.345-.885-.38-1.328-.172a4.667 4.667 0 11-2.967-8.79c.54-.118.993-.554.993-1.107V3z"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "selection_svg__paint0_linear",
  x1: 21.958,
  y1: 12.601,
  x2: 29.818,
  y2: 14.05,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgSelection = function SvgSelection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgSelection;